import React from 'react'
import { userRoles } from 'config/constants'
import Intersystem from 'screens/intersystem'
const ExperienceCreation = React.lazy(() => import(`screens/provider/experienceCreation`))
const Experience = React.lazy(() => import(`screens/experience`))
const Crud = React.lazy(() => import(`screens/crud`))
const Statistics = React.lazy(() => import(`screens/statistics`))
const NotFound = React.lazy(() => import(`screens/notFound`))
const Recovery = React.lazy(() => import(`screens/recovery`))

const notFoundCase = {
  key: `admin-requests`,
  component: NotFound,
}

const adminRoutes = [
  {
    path: [`/admin/`, `/admin/dashboard`, `/admin/experience`],
    url: `/admin/experience`,
    key: `admin-experience`,
    render: props => <Experience {...props} role={userRoles.Admin} />,
    text: `Experiencias`,
    title: `Experiencias`,
  },
  {
    path: `/admin/watch/:experienceId`,
    key: `validator-experiences-dashboard`,
    render: props => <ExperienceCreation {...props} role={userRoles.Admin} />,
    title: `Validar Experiencia`,
  },
  {
    path: `/admin/edit-experience/:experienceId`,
    key: `edit-experiences-dashboard`,
    render: props => <ExperienceCreation {...props} role={userRoles.Admin} />,
    title: `Editar Experiencia`,
  },
  
  {
    path: [`/admin/statistics`],
    url: `/admin/statistics`,
    key: `admin-statistics`,
    component: Statistics,
    title: `Estadisticas`,
    text: `Estadisticas`,
  },
  {
    path: `/usuario`,
    url: `/usuario/experiences`,
    key: `validator-admin-dashboard`,
    text: `Validador`,
    rol: `Validator`,
  },

  {
    path: `/validadornacional`,
    url: `/validadornacional`,
    key: `validator-nacional-admin-dashboard`,
    text: `Validador Nacional`,
    rol: `ValidatorNacional`,
  },
  {
    path: `/admin/crud/:entity`,
    url: `/admin/crud/usuarios`,
    key: `admin-usuarios`,
    component: Crud,
    text: `Usuarios`,
    exact: false,
    title: `Lista de Usuarios`,
  },
  {
    path: `/admin/crud/:entity`,
    url: `/admin/crud/roles`,
    key: `admin-roles`,
    text: `Roles`,
    component: Crud,
    exact: false,
    title: `Lista de Roles`,
  },
  {
    path: `/admin/crud/:entity`,
    url: `/admin/crud/regiones`,
    key: `admin-regiones`,
    component: Crud,
    text: `Regiones`,
    exact: false,
    title: `Lista de Regiones`,
  },
  {
    path: `/admin/crud/:entity`,
    url: `/admin/crud/macrozone`,
    key: `admin-macrozone`,
    component: Crud,
    text: `Macrozonas`,
    exact: false,
    title: `Lista de Macrozonas`,
  },
  {
    path: `/admin/crud/:entity`,
    url: `/admin/crud/zone`,
    key: `admin-zone`,
    component: Crud,
    text: `Zonas`,
    exact: false,
    title: `Lista de Zonas`,
  },
  {
    path: `/admin/crud/:entity`,
    url: `/admin/crud/destino`,
    key: `admin-destino`,
    component: Crud,
    text: `Destino`,
    exact: false,
    title: `Lista de Destino`,
  },
  {
    path: `/admin/crud/:entity`,
    url: `/admin/crud/categorias`,
    key: `admin-categorias`,
    component: Crud,
    text: `Categorias`,
    exact: false,
    title: `Lista de categorias`,
  },
  {
    path: `/admin/crud/:entity`,
    url: `/admin/crud/subcategorias`,
    key: `admin-subcategorias`,
    component: Crud,
    text: `Sub Categorias`,
    exact: false,
    title: `Lista de sub categorias`,
  },
  {
    path: `/intersystem`,
    url: `/intersystem`,
    key: `intersystem`,
    component: Intersystem,
    text: `Token`,
    exact: false,
    title: `Token Sistema`,
  },
]

const providerRoutes = [
  {
    path: [`/proveedor`, `/proveedor/dashboard`, `/proveedor/experiences`],
    url: `/proveedor`,
    key: `provider-experiences-dashboard`,
    render: props => <Experience {...props} role={userRoles.Provider} />,
    title: `Experiencias`,
    text: `Ir a mis experiencias`,
    showGobDisclamer: true,
  },
  {
    path: [
      `/proveedor/edit-experience/:experienceId`,
      `/proveedor/upgrade-experience/:experienceId`,
      `/proveedor/watch/:experienceId`,
      `/proveedor/new-experience`,
    ],
    url: `/proveedor/new-experience`,
    key: `new-experience`,
    render: props => <ExperienceCreation {...props} role={userRoles.Provider} />,
    title: `Nueva Experiencia`,
  },
]

const validatorRoutes = [
  {
    path: [`/usuario/`, `/usuario/dashboard`, `/usuario/experiences`],
    url: `/usuario/experiences`,
    key: `validator-experiences-dashboard`,
    render: props => <Experience {...props} role={userRoles.Validator} />,
    title: `Experiencias`,
    text: `Experiencias`,
  },
  {
    path: [`/usuario/validate-experience/:experienceId`, `/usuario/watch/:experienceId`],
    key: `validator-experiences-dashboard`,
    render: props => <ExperienceCreation {...props} role={userRoles.Validator} />,
    title: `Validar Experiencia`,
  },
  {
    path: `/admin`,
    url: `/admin`,
    key: `admin-usuario-dashboard`,
    text: `Admin`,
    rol: `Admin`,
  },
  {
    path: `/proveedor/edit-experience/:experienceId`,
    key: `edit-experiences-dashboard`,
    render: props => <ExperienceCreation {...props} role={userRoles.Validator} />,
    title: `Editar Experiencia`,
  },
]

const recoveryRoutes = [
  {
    path: [`/`, `/recovery`],
    key: `recovery-dashboard`,
    render: props => <Recovery {...props} />,
    title: `Recovery`,
  },
]
const validatorNacionalRoutes = [
  {
    path: [`/validadornacional/`, `/validadornacional/dashboard`, `/validadornacional/experience`],
    url: `/validadornacional/experience`,
    key: `validadornacional-experience`,
    render: props => (
      <Experience isNationalValidator={true} {...props} role={userRoles.ValidatorNacional} />
    ),
    text: `Experiencias`,
    title: `Experiencias`,
  },
  {
    path: `/validadornacional/edit-experience/:experienceId`,
    key: `edit-experiences-dashboard`,
    render: props => <ExperienceCreation {...props} role={userRoles.ValidatorNacional} />,
    title: `Editar Experiencia`,
  },
  {
    path: [
      `/validadornacional/validate-experience/:experienceId`,
      `/validadornacional/watch/:experienceId`,
    ],
    key: `validadornacional-experiences-dashboard`,
    render: props => (
      <ExperienceCreation
        isNationalValidator={true}
        {...props}
        role={userRoles.ValidatorNacional}
      />
    ),
    title: `Validar Experiencia`,
  },
  {
    path: `/admin`,
    url: `/admin`,
    key: `admin-usuario-dashboard`,
    text: `Admin`,
    rol: `Admin`,
  },
]

export const appRoutes = {
  [userRoles.Admin]: [...adminRoutes, notFoundCase],
  [userRoles.Provider]: [...providerRoutes, notFoundCase],
  [userRoles.Validator]: [...validatorRoutes, notFoundCase],
  [userRoles.Recovery]: [...recoveryRoutes, notFoundCase],
  [userRoles.ValidatorNacional]: [...validatorNacionalRoutes, notFoundCase],
}

export default appRoutes
